import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import {  NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {  ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { Vieweligibility271Component } from './vieweligibility271.component';
import { PhoneNumberFormatService } from 'src/app/phone-number-format.service';
import { Vieweligibility271RoutingModule } from './vieweligibility271-routing.module';
@NgModule({
  declarations: [Vieweligibility271Component],
  exports: [Vieweligibility271Component],
  imports: [
    CommonModule,
    GridModule,
    MaskedTextBoxModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    PDFExportModule,
    PdfViewerModule,
    NgxUiLoaderModule,
    Vieweligibility271RoutingModule
  ],
  providers: [ColumnChooserService,PhoneNumberFormatService,PageService,SortService,FilterService, ResizeService]
})
export class Vieweligibility271Module { }
